import { commonTemplates } from "./common";
import { speechTherapistTemplates } from "./speechTherapist";
import { psychologistTemplates } from "./psychologist";
import { psychotherapistTemplates } from "./psychotherapist";
import { occupationalTherapistTemplates } from "./occupationalTherapist";

export const ALL_SYSTEM_TEMPLATES = [
  ...commonTemplates,
  ...speechTherapistTemplates,
  ...psychologistTemplates,
  ...psychotherapistTemplates,
  ...occupationalTherapistTemplates,
].map((item) => ({ ...item, isSystem: true }));

export const getSystemTemplates = (clinicType) =>
  ALL_SYSTEM_TEMPLATES.filter((t) => t.clinicTypes.includes(clinicType));
